import React, { useState, useEffect } from 'react';
import { toast } from '../../../../utils/toast';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Button,
} from '@mui/material';
import Swal from 'sweetalert2';
//import withReactContent from 'sweetalert2-react-content'
import { AreaDto } from '../../../../services/api/areasApi';


interface AreasModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: AreaDto) => Promise<void>;
  title: string;
  initialData?: AreaDto;
  isLoading: boolean;
  isEdit?: boolean;
}

const AreasModal: React.FC<AreasModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  initialData,
  isLoading,
  isEdit = false,
}) => {
  const [formData, setFormData] = useState<AreaDto>({
    Nombre: '',
    Ceco: '',
    Activo: true,
  });

  // Usar SweetAlert2 con React
  //const SwalWithReact = withReactContent(Swal);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({ Nombre: '', Ceco: '', Activo: true });
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onClose();
    const confirmationResult = await Swal.fire({
      title: `¿Está seguro de ${isEdit ? 'actualizar' : 'guardar'}?`,
      text: isEdit
        ? 'Se actualizarán los datos de esta área.'
        : 'Se agregará un nuevo registro.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'Cancelar',
      customClass: {
        popup: 'swal-custom-zindex', // Clase personalizada para z-index
      },
    });

    if (confirmationResult.isConfirmed) {
      try {
        await onSubmit(formData);
        Swal.fire(
          'Éxito',
          isEdit
            ? 'El área fue actualizada correctamente.'
            : 'El área fue agregada correctamente.',
          'success'
        );
        onClose();
      } catch (error) {
        console.error('Error al guardar el área:', error);
        toast.error('No se pudo completar la acción.');
      }
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre"
            fullWidth
            required
            value={formData.Nombre}
            onChange={(e) => setFormData({ ...formData, Nombre: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="CECO"
            fullWidth
            required
            value={formData.Ceco}
            onChange={(e) => setFormData({ ...formData, Ceco: e.target.value })}
            sx={{ mb: 2 }}
          />
          {!isEdit && (
            <FormControlLabel
              control={
                <Switch
                  checked={formData.Activo}
                  onChange={(e) => setFormData({ ...formData, Activo: e.target.checked })}
                />
              }
              label="Activo"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={isLoading}>
            {isLoading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AreasModal;
